module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "sidebar",
    class: {
      slideOut: _vm.isSlideOut
    }
  }, [_c('div', {
    staticClass: "entry-item",
    on: {
      "click": _vm.handleContact
    }
  }, [_c('img', {
    staticClass: "entry-item-img",
    attrs: {
      "src": require("../../assets/images/client/earphone.png"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "entry-item",
    on: {
      "click": _vm.openDialog
    }
  }, [_c('img', {
    staticClass: "entry-item-img",
    attrs: {
      "src": require("../../assets/images/client/text.png"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "entry-item qrcode"
  }, [_c('el-popover', {
    attrs: {
      "placement": "left",
      "popper-class": "qrcode",
      "trigger": "hover"
    }
  }, [_c('img', {
    staticClass: "qrcode-img",
    attrs: {
      "src": require("../../assets/images/client/qrcode.jpg"),
      "alt": ""
    }
  }), _c('img', {
    staticClass: "entry-item-img",
    attrs: {
      "slot": "reference",
      "src": require("../../assets/images/client/weixin.png"),
      "alt": ""
    },
    slot: "reference"
  })])], 1), _c('div', {
    staticClass: "entry-item",
    on: {
      "click": _vm.backTop
    }
  }, [_c('img', {
    staticClass: "entry-item-img",
    attrs: {
      "src": require("../../assets/images/client/top_line.png"),
      "alt": ""
    }
  })])]), _c('el-dialog', {
    staticClass: "dialog width-500 v2-dialog",
    attrs: {
      "title": "建议和反馈问题",
      "visible": _vm.dialogVisible,
      "before-close": _vm.beforeClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "detail-form"
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "rules": _vm.rules
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "pull": 1
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择产品：",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-select', {
    staticClass: "select-300",
    model: {
      value: (_vm.addForm.productionId),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "productionId", $$v)
      },
      expression: "addForm.productionId"
    }
  }, _vm._l((_vm.productList), function(item) {
    return _c('el-option', {
      key: item._id,
      attrs: {
        "value": item._id,
        "label": item.name
      }
    })
  }))], 1)], 1)], 1), _c('el-row', [_c('el-col', {
    attrs: {
      "pull": 1
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "问题建议：",
      "label-width": _vm.formLabelWidth,
      "prop": "contents"
    }
  }, [_c('el-input', {
    staticClass: "input-300",
    attrs: {
      "rows": 4,
      "type": "textarea",
      "placeholder": "请简要描述问题或建议"
    },
    model: {
      value: (_vm.addForm.contents),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "contents", $$v)
      },
      expression: "addForm.contents"
    }
  })], 1)], 1)], 1), _c('el-row', [_c('el-col', {
    attrs: {
      "pull": 1
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "上传图片：",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "client-upload",
    class: {
      hidePic: _vm.hideUpload
    },
    attrs: {
      "action": _vm.actionUrl,
      "type": "drag",
      "limit": _vm.limitCount,
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "on-change": _vm.handleChange,
      "on-success": _vm.handleSuccess,
      "accept": ".jpg,.png,.jpeg,.PNG,.gif",
      "auto-upload": false,
      "file-list": _vm.fileList,
      "on-remove": _vm.handleRemove
    }
  }, [_c('div', {
    staticClass: "upload_icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/client/upload_img.png"),
      "alt": ""
    }
  }), _c('span', [_vm._v("大小在2M以内")])])])], 1)], 1)], 1), _c('div', {
    staticClass: "form-footer"
  }, [_c('el-button', {
    staticClass: "customStyle",
    attrs: {
      "loading": _vm.submitEditLoading,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitEdit('addForm')
      }
    }
  }, [_vm._v("提 交")])], 1)], 1)], 1)]), _c('el-dialog', {
    staticClass: "dialog v2-dialog",
    attrs: {
      "visible": _vm.previewDialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.previewDialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-edd556d0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/FastEntry.vue
// module id = 413
// module chunks = 0